import React from 'react';
import {
	BrowserRouter as Router,
	Redirect,
	Route,
	Switch,
} from 'react-router-dom';
import ScrollToTopRoute from './ScrollToTopRoute';
import './App.css';
import './App-mobile.css';

import MenuBar from './components/layout/Navbar';

import Dashboard from './components/dashboard/Dashboard';
import ProjectDetails from './components/projects/ProjectDetails';
import SignIn from './components/auth/SignIn';
import SignUp from './components/auth/SignUp';

import HomeLayout from './pages/HomeLayout';
import AboutLayout from './components/website/about/AboutLayout';
import ContactLayout from './components/website/contact/ContactLayout';

import CoursesLayout from './components/website/courses/CoursesLayout';
import CourseDetails from './components/website/courses/CourseDetails';

const App = () => {
	return (
		<Router>
			<div className='App'>
				<MenuBar />
				<Switch>
					<Route exact path='/'>
						<Redirect to='/home' />
					</Route>
					<ScrollToTopRoute exact path='/dashboard' component={Dashboard} />
					<ScrollToTopRoute
						exact
						path='/project/:id'
						component={ProjectDetails}
					/>

					<ScrollToTopRoute exact path='/home' component={HomeLayout} />
					<ScrollToTopRoute exact path='/about' component={AboutLayout} />
					<ScrollToTopRoute exact path='/courses' component={CoursesLayout} />
					<ScrollToTopRoute exact path='/contact' component={ContactLayout} />
					<ScrollToTopRoute
						exact
						path='/course/:id'
						component={CourseDetails}
					/>
					<ScrollToTopRoute exact path='/signin' component={SignIn} />
					<ScrollToTopRoute exact path='/signup' component={SignUp} />
				</Switch>
				{/* <Footer /> */}
			</div>
		</Router>
	);
};

export default App;
